
interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string;
        type?: string;
        title?: string;
        description?: string;
        url?: string;
        site_name?: string;
        updated_time?: string;
        image?: string;
        image_secure_url?: string;
        image_width?: number;
        image_height?: number;
        image_alt?: string;
        image_type?: string;
        video?: string;
        video_duration?: number;
        video_upload_date?: string;
        video_allow_embed?: boolean;
    };
    twitter?: {
        card?: string;
        title?: string;
        description?: string;
        image?: string;
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    treatmentAreas1: TreatmentArea[];
    treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string;
        beforeAfter: string[];
        introductionImage?: string;
    };
    product: {
        id: number;
        title: string;
        price: number;
        description: string;
    };
}

export const buttFillers: {
    en: LanguageContent;
    ar: LanguageContent;
    shared: SharedData;
} =
{
    "en": {
        "url": "",
        "meta": {
            "title": "Butt Filler Dubai | Non-Surgical Butt Lift, Hip Dip Fillers",
            "description": "Butt filler offer a non-surgical alternative to a Brazilian Butt Lift (BBL), enhancing curves naturally with safe, quick injections. Visit Elite Body Home in Dubai for expert care and personalized treatments to achieve a fuller, sculpted look.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/services/butt-fillers-dubai/",
            "og": {
                "locale": "en_US",
                "type": "article",
                "title": "Butt Filler Dubai | Non-Surgical Butt Lift, Hip Dip Fillers",
                "description": "Butt filler offer a non-surgical alternative to a Brazilian Butt Lift (BBL), enhancing curves naturally with safe, quick injections. Visit Elite Body Home in Dubai for expert care and personalized treatments to achieve a fuller, sculpted look.",
                "url": "https://elitebodyhome.com/services/butt-fillers-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-03-03T15:27:48+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/butt-filler-Header.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/butt-filler-Header.jpg",
                "image_width": 1080,
                "image_height": 708,
                "image_alt": "butt filler dubai",
                "image_type": "image/jpeg",
                "video": "https://player.vimeo.com/video/1022086510?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1#t=",
                "video_duration": 56,
                "video_upload_date": "2024-10-22T08:08:07+00:00",
                "video_allow_embed": true
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "Butt Filler Dubai | Non-Surgical Butt Lift, Hip Dip Fillers",
                "description": "Butt filler offer a non-surgical alternative to a Brazilian Butt Lift (BBL), enhancing curves naturally with safe, quick injections. Visit Elite Body Home in Dubai for expert care and personalized treatments to achieve a fuller, sculpted look.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/butt-filler-Header.jpg"
            },

        },
        "breadcrumbs": ["Home", "Services", "Butt Filler"],
        "hero": {
            "title": "Dubai Butt Filler",
            "subtitle": "Butt Filler in Dubai",
            "description": "A woman always desires a perfect body shape that she dreams of, and with the help of these advanced butt fillers, it has become very easy to achieve it. This innovative non-surgical treatment enables you to improve your curves, counteract the effects of aging, gravity, and weight variation, and restore the firmness and volume that characterize a youthful figure."
        },
        "howItWorks": {
            "title": "Quick Facts: Butt Filler",
            "description": "What It Is: Injections — performed without surgery — that add volume to and contour the buttocks. Time: 30-60 minutes (little to no downtime). Results: Immediately with hyaluronic acid fillers. Longevity: Then 1-3 years, depending on the filler. Pain Level: Mild; numbness agents are used to provide comfort. Possible Side Effects: Temporary swelling, bruising or soreness at injection sites. Safety: FDA-approved fillers. Dubai Price: AED 2,999 – AED 4,999."
        },
        "procedureSteps": {
            "heading": "What is Open Butt Fillers Injection Procedure?",
            "para": "We take care of your Butt Filler in 4 Simple Steps!",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "The consultation allows our specialists to analyze your objectives and decide the best filler type and amount necessary to accomplish the results you need.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Preparation & Target Marking",
                    "desc": "To ensure sterility, the area of treatment is cleaned, and the practitioner marks important points for injection so that filler is placed precisely for natural, symmetrical results.",
                    "icon": "fa-solid fa-map-marked-alt"
                },
                {
                    "title": "Butt Filler Injection",
                    "desc": "Butt injections are carefully injected in the marked regions of the buttocks with a fine needle or cannula.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Final Assessment",
                    "desc": "The practitioner will review the results, making any corrections if needed to achieve symmetry and the preferred degree of improvement.",
                    "icon": "fa-solid fa-check-circle"
                }
            ]
        },
        "benefits": {
            "heading": "Advantages of Non-Surgical Buttock Augmentation",
            "subheading": "",
            "para": "However, FDA-approved buttock injections can provide a variety of safe, effective, and non-invasive options for those looking to enhance their body contour. Below are the key advantages:",
            "items": [
                {
                    "title": "Minimally Invasive",
                    "desc": "Butt fillers offer a non-invasive option compared to surgical procedures, omitting the need for incisions, anesthetic, or extended downtime.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "Improves Shape And Volume",
                    "desc": "Increases the volume of the buttocks, improving the shape and creating a fuller, more lifted appearance.",
                    "icon": "fa-solid fa-arrows-alt-v"
                },
                {
                    "title": "Fills Hip Dips",
                    "desc": "Covers fall in the fat of the hip joints, making the silhouette smoother and more proportional.",
                    "icon": "fa-solid fa-draw-polygon"
                },
                {
                    "title": "Instant Gratification",
                    "desc": "Start to see results immediately after the treatment, with full effects visible as the filler integrates.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Controlled Filling",
                    "desc": "The volume and location of the filler are customized to your body goals, yielding results that look natural and balanced.",
                    "icon": "fa-solid fa-sliders-h"
                },
                {
                    "title": "Targets Aging and Gravity",
                    "desc": "Restores lost volume and helps fight sagging due to aging, gravity, or weight changes.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "Zero Downtime",
                    "desc": "Get back to daily activities right away; perfect for busy lifestyles.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Body Confidence",
                    "desc": "Improving the contours of the buttocks and addressing imperfections such as hip dips can lead to an increase in self-esteem and body confidence.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "eligibility": {
            "heading": "Who Is the Right Candidate for Butt Injections?",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "Desire a larger rear end",
                    "desc": "Want a more plump look",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "Want to turn back time",
                    "desc": "Treat skin features such as drooping flesh or decrease of skin elasticity.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "Wanting fillers for a more natural appearance",
                    "desc": "",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "Hip dip fillers needed",
                    "desc": "For a balanced smooth silhouette.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "Having volume loss",
                    "desc": "Due to aging, weight changes or gravity.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "Otherwise healthy",
                    "desc": "People with no medical complications.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "Set realistic expectations",
                    "desc": "For nuanced, natural-looking results.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "No allergens",
                    "desc": "For the filling material.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "No downtime",
                    "desc": "For a busy lifestyle.",
                    "icon": "fa-solid fa-check"
                }
            ]
        },
        "preparationTips": {
            "heading": "Before Butt Lift/Hip Dip Fillers Procedure",
            "subheading": "",
            "para": "Adequate preparation can lead to a smoother procedure with improved results. This is how to prepare for your butt filler treatment:",
            "items": [
                {
                    "title": "Allergy Test",
                    "desc": "Make sure there is no allergic reaction to the fillers; do an allergic test.",
                    "icon": "fa-solid fa-allergies"
                },
                {
                    "title": "Avoid Sunbathing",
                    "desc": "Do not sunbath before the treatment.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Quit Smoking",
                    "desc": "Quitting smoking at least two weeks before will help your body heal.",
                    "icon": "fa-solid fa-smoking-ban"
                },
                {
                    "title": "Avoid Blood Thinners",
                    "desc": "Ndo so with aspirin or ibuprofen, both blood-otherapeutic medications.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Drink a lot of water to stay hydrated.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "Wear Comfortable Clothing",
                    "desc": "On the day of the procedure, wear loose-fitting, comfortable clothing.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "Disclose Medications",
                    "desc": "Talk to your moon if you are taking any medications that are still ongoing.",
                    "icon": "fa-solid fa-file-medical"
                },
                {
                    "title": "Follow Instructions",
                    "desc": "All pre-procedure instructions provided to you by your specialist should be followed.",
                    "icon": "fa-solid fa-list-ol"
                }
            ]
        },
        "results": {
            "heading": "Butt Fillers Before and After",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "Immediate Results",
                    "desc": "Results are visible immediately after the treatment, though final results will be fully realized once any swelling subsides over the following days.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "Longevity",
                    "desc": "Results typically last between 12 and 18 months, depending on factors such as the type of filler used and your body's metabolism.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare",
            "subheading": "",
            "para": "Along with minimizing swelling and bruising, following the guidelines can also help prevent complications like infection.",
            "items": [
                {
                    "title": "Avoid Sitting",
                    "desc": "Do not sit on your butt for throughout a day for 24-48 hours.",
                    "icon": "fa-solid fa-chair"
                },
                {
                    "title": "Avoid Vigorous Activity",
                    "desc": "For the first week, avoid vigorous activity or heavy exercise.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "Wear Loose Clothing",
                    "desc": "Wear loose clothing if you can to minimize any pressure on the treated area.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Keep how hydrated to help the recovery and help keep the results of fillers.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "Avoid Sun Exposure",
                    "desc": "Stay out of direct sun or from tanning the invective area.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "Follow Massage Advice",
                    "desc": "If your doctor recommends a post-procedure massage, follow their advice.",
                    "icon": "fa-solid fa-hands"
                },
                {
                    "title": "Monitor for Complications",
                    "desc": "Keep an eye out for any strange swelling, redness, or pain and reach out to your specialist, as necessary.",
                    "icon": "fa-solid fa-exclamation-triangle"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How long do butt injections last?",
                    "answer": "Butt injections typically last between 12-24 months, depending on the type of filler and individual factors like metabolism."
                },
                {
                    "question": "What is the best filler for buttocks?",
                    "answer": "Hyaluronic acid-based fillers and collagen-stimulating fillers are popular for providing natural, long-lasting results for buttocks enhancement."
                },
                {
                    "question": "Can you sit after bum fillers?",
                    "answer": "It's recommended to avoid sitting directly on your buttocks for 24-48 hours after the procedure to ensure optimal results and prevent pressure on the area."
                },
                {
                    "question": "Hyaluronic acid buttock injections side effects?",
                    "answer": "Common side effects include mild swelling, bruising, or redness, which usually resolve within a few days. Severe reactions are rare but possible."
                },
                {
                    "question": "Are butt fillers safe?",
                    "answer": "Yes, butt fillers are generally safe when performed by a certified, experienced professional, following proper aftercare instructions."
                },
                {
                    "question": "Is HYAcorp safe?",
                    "answer": "yes, is a safe and FDA-approved dermal filler made from high-quality, biocompatible hyaluronic acid."
                },
                {
                    "question": "How long does the procedure take?",
                    "answer": "The procedure usually takes about 60 minutes, depending on the amount of filler being used and the desired results."
                },
                {
                    "question": "Is the treatment painful?",
                    "answer": "Most patients experience minimal discomfort during the procedure. A topical numbing cream or local anesthetic is applied to reduce any pain from the injections."
                },
                {
                    "question": "When will I see results?",
                    "answer": "Results are visible immediately after the treatment, though final results will be fully realized once any swelling subsides over the following days."
                },
                {
                    "question": "How long do butt filler results last?",
                    "answer": "Results typically last between 12 and 18 months, depending on factors such as the type of filler used and your body's metabolism."
                },
                {
                    "question": "How many sessions are required?",
                    "answer": "Most patients achieve their desired results in one session, but additional sessions can be scheduled depending on your aesthetic goals."
                }
            ]
        },
        "treatmentAreas1": [
            {
                "ar": "V Shape Butt",
                "title": "Butt-5-05",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Butt-5-05.jpg"
            },
            {
                "ar": "A Shape Butt",
                "title": "Butt-5-04",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Butt-5-04.jpg"
            },
            {
                "ar": "Square Butt",
                "title": "Butt-5-03",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Butt-5-03.jpg"
            }
        ],
        "treatmentAreas2": [
            {
                "ar": "Heart Butt",
                "title": "Butt-5-02",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Butt-5-02.jpg"
            },
            {
                "ar": "Round Butt",
                "title": "Butt-5-01",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Butt-5-01.jpg"
            }
        ]
    },
    "shared": {
        "images": {
            "introductionImage": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/elementor/thumbs/esfesfef-r1rv64p7fdu5z01l0l70eprmen5po56s7owtxlx1h4.jpg",
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/butt-filler-Header.jpg",
            "beforeAfter": [
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/butt-fillers-in-dubai-1.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/butt-fillers-in-dubai-2.jpg",
                "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/butt-fillers-in-dubai-3.jpg"
            ]
        },
        "product": {
            "id": 105,
            "title": "Non-Surgical Butt Enhancement Package",
            "price": 450,
            "description": "Professional butt filler treatment providing a non-surgical alternative to BBL, using safe dermal fillers to enhance curves, fill hip dips, and create a naturally sculpted silhouette. Includes consultation and follow-up care."
        }
    },

    "ar": {
        "url": "",
        "meta": {
            "title": "فيلر المؤخرة في دبي | تكبير المؤخرة بدون جراحة - حشوات انخفاض الورك",
            "description": "يقدم فيلر المؤخرة بديلاً غير جراحي لعملية تكبير المؤخرة البرازيلية (BBL)، حيث يعزز المنحنيات بشكل طبيعي بحقن آمنة وسريعة. زوروا ايليت بودي هوم في دبي للحصول على رعاية خبراء وعلاجات مخصصة لتحقيق مظهر ممتلئ ومنحوت.",
            "robots": "follow, index, max-snippet:-1, max-video-preview:-1, max-image-preview:large",
            "canonical": "https://elitebodyhome.com/servces/butt-fillers-dubai/",
            "og": {
                "locale": "ar_AR",
                "type": "article",
                "title": "فيلر المؤخرة في دبي | تكبير المؤخرة بدون جراحة - حشوات انخفاض الورك",
                "description": "يقدم فيلر المؤخرة بديلاً غير جراحي لعملية تكبير المؤخرة البرازيلية (BBL)، حيث يعزز المنحنيات بشكل طبيعي بحقن آمنة وسريعة. زوروا ايليت بودي هوم في دبي للحصول على رعاية خبراء وعلاجات مخصصة لتحقيق مظهر ممتلئ ومنحوت.",
                "url": "https://elitebodyhome.com/services/butt-fillers-dubai/",
                "site_name": "elitebodyhome.com",
                "updated_time": "2025-03-03T15:27:48+00:00",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/butt-filler-Header.jpg",
                "image_secure_url": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/butt-filler-Header.jpg",
                "image_width": 1080,
                "image_height": 708,
                "image_alt": "فيلر المؤخرة دبي",
                "image_type": "image/jpeg",
                "video": "https://player.vimeo.com/video/1022086510?color&autopause=0&loop=0&muted=0&title=1&portrait=1&byline=1#t=",
                "video_duration": 56,
                "video_upload_date": "2024-10-22T08:08:07+00:00",
                "video_allow_embed": true
            },
            "twitter": {
                "card": "summary_large_image",
                "title": "فيلر المؤخرة في دبي | تكبير المؤخرة بدون جراحة - حشوات انخفاض الورك",
                "description": "يقدم فيلر المؤخرة بديلاً غير جراحي لعملية تكبير المؤخرة البرازيلية (BBL)، حيث يعزز المنحنيات بشكل طبيعي بحقن آمنة وسريعة. زوروا ايليت بودي هوم في دبي للحصول على رعاية خبراء وعلاجات مخصصة لتحقيق مظهر ممتلئ ومنحوت.",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/butt-filler-Header.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "فيلر المؤخرة"],
        "hero": {
            "title": "فيلر المؤخرة في دبي",
            "subtitle": "فيلر المؤخرة في دبي",
            "description": "تسعى المرأة دائمًا للحصول على قوام مثالي كما تحلم به، ومع تطوّر تقنيات فيلر المؤخرة الحديثة، أصبح من السهل تحقيق هذا الحلم. يُعد هذا الإجراء المبتكر غير الجراحي وسيلة فعّالة لتحسين شكل الجسم ومواجهة آثار التقدم في العمر، وتقلبات الوزن، حيث يعمل على استعادة تماسك البشرة وحجمها المرتبطان بالمظهر الشبابي."
        },
        "howItWorks": {
            "title": "معلومات سريعة عن فيلر المؤخرة",
            "description": "الحقن: يُحفن الفيلر بدون جراحة، ويعمل على إضافة حجم للمؤخرة وتحديدها. الوقت: يستغرق الإجراء من 30 إلى 60 دقيقة، وقد يتطلب فترة تعافي قصيرة أو بدون نهائيًا. النتائج: تظهر النتائج فورًا مع الفيلر المكون من حمض الهيالورونيك. العمر الافتراضي: يدوم من سنة إلى 3 سنوات حسب نوع الفيلر. درجة الألم: يسبب الإجراء ألمًا طفيفًا، ويمكن استخدام مخدر موضعي لضمان الراحة أثناء الإجراء. الأثار الجانبية المحتملة: قد يحدث تورم مؤقت، أو كدمات أو ألم في مواقع الحقن. الأمان: إجراء معتمد من إدارة الغذاء والدواء (FDA). الأسعار في دبي: تتراوح الأسعار بين 2,999 درهم إماراتي إلى 4,999 درهم إماراتي."
        },
        "procedureSteps": {
            "heading": "ما هو إجراء فيلر المؤخرة؟",
            "para": "نقوم برعاية فيلر المؤخرة في 4 خطوات بسيطة!",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "تتيح لكِ جلسة استشارية مع أطبائنا لمناقشة أهدافك، وتحديد نوع الفيلر المناسب والكمية المطلوبة لتحقيق النتائج المرجوّة.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "الاستعداد وتحديد نقاط الحقن",
                    "desc": "تُنظف المنطقة المستهدفة لضمان التعقيم، ثم يُحدد الطبيب نقاط الحقن الأساسية بدقة لضمان توزيع الفيلر بشكل متناسق وطبيعي على الجانبين.",
                    "icon": "fa-solid fa-map-marked-alt"
                },
                {
                    "title": "حقن فيلر المؤخرة",
                    "desc": "تُحقن مادة الفيلر بعناية في المناطق المحددة باستخدام إبرة أو قنية دقيقة.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "التقييم النهائي",
                    "desc": "يُراجع الطبيب النتائج بعناية بعد الانتهاء من الحقن، ويقوم بإجراء أي تعديلات لازمة لضمان التناسق التام وتحقيق درجة التحسين المطلوبة.",
                    "icon": "fa-solid fa-check-circle"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد تكبير المؤخرة بدون جراحة",
            "subheading": "",
            "para": "توفر حقن الفيلر المعتمدة من إدارة الغذاء والدواء (FDA) خيارات آمنة وفعّالة وغير جراحية لتحديد شكل الجسم وتعزيز تناسقه. إليك أبرز المزايا:",
            "items": [
                {
                    "title": "إجراء غير جراحي",
                    "desc": "يُعد فيلر المؤخرة بديل غير جراحي للإجراءات التقليدية الجراحية، دون الحاجة إلى تخدير أو شقوق جراحية أو فترة تعافي طويلة.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "تحسين شكل المؤخرة وزيادة حجمها",
                    "desc": "يساعد على تكبير المؤخرة، مما يمنحها مظهرًا ممتلئًا ومرفوعًا وأكثر تحديدًا.",
                    "icon": "fa-solid fa-arrows-alt-v"
                },
                {
                    "title": "ملء انخفاضات الورك",
                    "desc": "يعمل الفيلر على تعبئة الانخفاضات في منطقة الورك للحصول على قوام أكثر تناسقًا وانسيابية.",
                    "icon": "fa-solid fa-draw-polygon"
                },
                {
                    "title": "شعور بالرضا فورًا بعد الإجراء",
                    "desc": "تبدأ النتائج بالظهور فورًا بعد الجلسة، بينما تظهر النتائج الكاملة بشكل تدريجي مع اندماج الفيلر مع الأنسجة.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "تحكم دقيق في النتائج",
                    "desc": "يتم تخصيص الكمية والمناطق المستهدفة وفقًا لأهدافك الجمالية، مما يوفر نتائج طبيعية ومتوازنة.",
                    "icon": "fa-solid fa-sliders-h"
                },
                {
                    "title": "مواجهة آثار التقدم في العمر",
                    "desc": "يساعد على تعويض الفقدان الطبيعي في الحجم نتيجة العمر أو فقدان الوزن.",
                    "icon": "fa-solid fa-hourglass-half"
                },
                {
                    "title": "لا يتطلب فترة تعافي",
                    "desc": "يمكنك العودة إلى أنشطتك اليومية فورًا، مما يجعله إجراء مناسب تمامًا لأسلوب الحياة المزدحم.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "يساهم تحسين شكل الجسم العام في تعزيز شعورك بالرضا والثقة بمظهرك.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "eligibility": {
            "heading": "من هو المرشح المناسب لفيلر المؤخرة؟",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "الرغبة في تكبير المؤخرة",
                    "desc": "إذا كنت ترغب في تكبير المؤخرة للحصول على مظهر ممتلئ ومتناسق.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "استعادة الشكل السابق",
                    "desc": "إذا كنت ترغب في استعادة شكل الجلد السابق وشد الترهلات الناتجة عن التقدم في العمر أو ضعف مرونة البشرة.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "تحسين المظهر بشكل طبيعي",
                    "desc": "إذا كنت ترغب في تحسين مظهر المؤخرة بطريقة طبيعية.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "علاج انخفاضات الورك",
                    "desc": "إذا كنت ترغب في معالجة انخفاضات الورك للحصول على قوام ناعم وانسيابي.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "فقدان الحجم",
                    "desc": "إذا كنت تعاني من فقدان الحجم نتيجة التقدّم في العمر أو تغير الوزن.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "صحة عامة جيدة",
                    "desc": "إذا كنت تتمتع بصحة عامة جيدة ولا تعاني من أي حالات صحية مزمنة.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "توقعات واقعية",
                    "desc": "إذا كنت تمتلك توقعات واقعية لنتائج طبيعية ودقيقة.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "عدم وجود حساسية",
                    "desc": "إذا كنت لا تعاني من حساسية تجاه مواد الفيلر.",
                    "icon": "fa-solid fa-check"
                },
                {
                    "title": "عدم الرغبة في فترة تعافي",
                    "desc": "إذا كنت تبحث عن نتائج فورية دون الحاجة إلى فترة تعافي طويلة، مما يناسب أنماط الحياة المزدحمة.",
                    "icon": "fa-solid fa-check"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد قبل إجراء فيلر المؤخرة",
            "subheading": "",
            "para": "يضمن لك التحضير الجيد لفيلر المؤخرة أو ملء انخفاضات الورك تجربة سلسة ونتائج أفضل. إليك أهم التعليمات التي يجب اتباعها قبل الجلسة:",
            "items": [
                {
                    "title": "اختبار الحساسية",
                    "desc": "يجب إجراء اختبار حساسية للتأكد من عدم وجود رد فعل تحسسي تجاه الفيلر.",
                    "icon": "fa-solid fa-allergies"
                },
                {
                    "title": "تجنب التعرض للشمس",
                    "desc": "تجنّبي التعرض لأشعة الشمس أو جلسات التان قبل الإجراء.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "الإقلاع عن التدخين",
                    "desc": "يلزم التوقف عن التدخين لمدة أسبوعين على الأقل قبل الجلسة لتعزيز عملية التعافي.",
                    "icon": "fa-solid fa-smoking-ban"
                },
                {
                    "title": "تجنب مميعات الدم",
                    "desc": "تجنّبي تناول الأدوية المميعة للدم مثل الأسبرين أو الإيبوبروفين.",
                    "icon": "fa-solid fa-pills"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "يجب شرب كميات كافية من الماء للحفاظ على ترطيب الجسم والبشرة.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "ارتداء ملابس مريحة",
                    "desc": "ارتدي ملابس واسعة ومريحة في يوم الإجراء.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "الإفصاح عن الأدوية",
                    "desc": "أخبري الطبيب بأي أدوية تتناولينها حاليًا.",
                    "icon": "fa-solid fa-file-medical"
                },
                {
                    "title": "اتباع التعليمات",
                    "desc": "التزمي بجميع إرشادات قبل الإجراء التي سيزودك بها أخصائي التجميل.",
                    "icon": "fa-solid fa-list-ol"
                }
            ]
        },
        "results": {
            "heading": "فيلر المؤخرة قبل وبعد",
            "subheading": "",
            "para": "",
            "items": [
                {
                    "title": "نتائج فورية",
                    "desc": "تظهر النتائج فورًا بعد الإجراء، مع ظهور النتائج النهائية بعد زوال أي تورم خلال الأيام التالية.",
                    "icon": "fa-solid fa-eye"
                },
                {
                    "title": "المدة الزمنية",
                    "desc": "تدوم النتائج عادةً من 12 إلى 18 شهرًا، اعتمادًا على عوامل مثل نوع الفيلر المستخدم ومعدل الأيض في الجسم.",
                    "icon": "fa-solid fa-calendar-check"
                }
            ]
        },
        "aftercareTips": {
            "heading": "إرشادات العناية بعد الجلسة",
            "subheading": "",
            "para": "يجب اتباع إرشادات العناية بعد العلاج بدقة لضمان أفضل النتائج وتقليل التورم والكدمات، بالإضافة إلى الوقاية من أي مضاعفات مثل حدوث عدوى.",
            "items": [
                {
                    "title": "تجنب الجلوس",
                    "desc": "تجنبي الجلوس لفترات طويلة على المؤخرة لمدة 24 إلى 48 ساعة بعد العلاج.",
                    "icon": "fa-solid fa-chair"
                },
                {
                    "title": "تجنب الأنشطة المجهدة",
                    "desc": "تجنبي الأنشطة المجهدة أو التمارين الرياضية الثقيلة خلال الأسبوع الأول.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "ارتداء ملابس فضفاضة",
                    "desc": "ارتدي ملابس فضفاضة لتقليل الضغط على المنطقة المعالجة.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "احرصي على الحفاظ على الترطيب من خلال شرب الكثير من الماء لدعم عملية الشفاء والحفاظ على نتائج الفيلر.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "تجنب التعرض للشمس",
                    "desc": "تجنبي التعرض المباشر لأشعة الشمس أو جلسات التان للمنطقة المعالجة.",
                    "icon": "fa-solid fa-sun"
                },
                {
                    "title": "اتباع تعليمات التدليك",
                    "desc": "اتبعي تعليمات الطبيب إذا أوصى بتدليك المنطقة بعد الإجراء.",
                    "icon": "fa-solid fa-hands"
                },
                {
                    "title": "مراقبة المضاعفات",
                    "desc": "راقبي أي تورم أو احمرار أو ألم غير طبيعي وراجعي الطبيب إذا لزم الأمر.",
                    "icon": "fa-solid fa-exclamation-triangle"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة المتكررة",
            "subheading": "",
            "items": [
                {
                    "question": "كم تدوم حقن المؤخرة؟",
                    "answer": "تدوم حقن المؤخرة عادةً من 12 إلى 24 شهرًا، اعتمادًا على نوع الفيلر والعوامل الفردية مثل معدل الأيض."
                },
                {
                    "question": "ما هو أفضل فيلر للمؤخرة؟",
                    "answer": "تعتبر فيلرات حمض الهيالورونيك والفيلرات المحفزة للكولاجين الأكثر شيوعًا لتوفير نتائج طبيعية وطويلة الأمد لتكبير المؤخرة."
                },
                {
                    "question": "هل يمكن الجلوس بعد فيلر المؤخرة؟",
                    "answer": "يُنصح بتجنب الجلوس مباشرة على المؤخرة لمدة 24-48 ساعة بعد الإجراء لضمان نتائج مثالية ومنع الضغط على المنطقة."
                },
                {
                    "question": "ما هي الآثار الجانبية لحقن حمض الهيالورونيك للمؤخرة؟",
                    "answer": "تشمل الآثار الجانبية الشائعة تورمًا خفيفًا أو كدمات أو احمرارًا، والتي تختفي عادةً خلال بضعة أيام. ردود الفعل الشديدة نادرة ولكنها ممكنة."
                },
                {
                    "question": "هل فيلر المؤخرة آمن؟",
                    "answer": "نعم، يعتبر فيلر المؤخرة آمنًا بشكل عام عند إجرائه بواسطة أخصائي معتمد وذو خبرة، مع اتباع تعليمات العناية اللاحقة."
                },
                {
                    "question": "هل HYAcorp آمن؟",
                    "answer": "نعم، هو فيلر جلدي آه ومعتمد من FDA مصنوع من حمض الهيالورونيك عالي الجودة والمتوافق حيويًا."
                },
                {
                    "question": "كم تستغرق مدة الإجراء؟",
                    "answer": "يستغرق الإجراء عادةً حوالي 60 دقيقة، اعتمادًا على كمية الفيلر المستخدمة والنتائج المرجوة."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "يشعر معظم المرضى بألم طفيف أثناء الإجراء. يتم تطبيق كريم مخدر أو مخدر موضعي لتقليل أي ألم من الحقن."
                },
                {
                    "question": "متى سأرى النتائج؟",
                    "answer": "تظهر النتائج فورًا بعد العلاج، مع ظهور النتائج النهائية بعد زوال أي تورم خلال الأيام التالية."
                },
                {
                    "question": "كم تدوم نتائج فيلر المؤخرة؟",
                    "answer": "تدوم النتائج عادةً من 12 إلى 18 شهرًا، اعتمادًا على عوامل مثل نوع الفيلر المستخدم ومعدل الأيض في الجسم."
                },
                {
                    "question": "كم عدد الجلسات المطلوبة؟",
                    "answer": "يحقق معظم المرضى النتائج المرجوة في جلسة واحدة، ولكن يمكن جدولة جلسات إضافية حسب الأهداف الجمالية."
                }
            ]
        },
        "treatmentAreas1": [
            {
                "ar": "مؤخرة على شكل V",
                "title": "Butt-5-05",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Butt-5-05.jpg"
            },
            {
                "ar": "مؤخرة على شكل A",
                "title": "Butt-5-04",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Butt-5-04.jpg"
            },
            {
                "ar": "مؤخرة مربعة",
                "title": "Butt-5-03",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Butt-5-03.jpg"
            }
        ],
        "treatmentAreas2": [
            {
                "ar": "مؤخرة على شكل قلب",
                "title": "Butt-5-02",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Butt-5-02.jpg"
            },
            {
                "ar": "مؤخرة مستديرة",
                "title": "Butt-5-01",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Butt-5-01.jpg"
            }
        ]
    }

};
